<template>
	<v-layout>
		<v-flex sm12 md6>
			<div class="add-event-step-header">Event Frequency</div>
			<v-radio-group v-model="frequency" :mandatory="false">
				<div v-for="type in types" :key="type.value">
					<v-radio :label="type.title" :value="type.value" class="mt-2 mb-1 add-event-radio-selection"></v-radio>
					<div class="add-event-radio-description">
						{{type.description}}
					</div>
					<div v-if="frequency === 'recurring' && type.value === 'recurring'">
						<v-radio-group v-model="recurringFrequency" class="ml-5">
							<v-radio label="Weekly" value="weekly" class="mt-4 mb-1 add-event-radio-selection-small"></v-radio>
							<v-radio label="Monthly" value="monthly" class="mt-2 mb-1 add-event-radio-selection-small"></v-radio>
						</v-radio-group>
						<!-- Repeat by: Add day of month or day of week? -->
					</div>
				</div>
			</v-radio-group>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text>
					<p class="add-event-example-sub-header-light">Tips</p>
					<p class="add-event-example-sub-header">Recurring</p>
					<p class="add-event-example-content">We recommend hosting recurring events once a week.  This saves you time setting up wrkprtys and gives guests the ability to return to your events on a regular basis.</p>
				</v-card-text>
			</v-card>
		</v-flex>
		<v-dialog scrollable v-model="infoDialog">
			<v-card style="width: 100%">
				<v-card-title class="mb-0 pb-2 pt-3">
					<p class="add-event-example-sub-header-light">Tips</p>
				</v-card-title>
				<v-divider class="pt-0 mt-0">
				</v-divider>
				<v-card-text style="max-height:50vh;">
					<p class="add-event-example-sub-header">Recurring</p>
					<p class="add-event-example-content">We recommend hosting recurring events once a week.  This saves you time setting up wrkprtys and gives guests the ability to return to your events on a regular basis.</p>
				</v-card-text>
				<v-divider>
				</v-divider>
				<v-card-actions>
					<v-spacer>
					</v-spacer>
					<v-btn @click="infoDialog=false">Close</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <div class="mb-3 add-event-step-info-link" @click="infoDialog=true"><v-icon class="add-event-step-info-icon">fa-info-circle</v-icon> Tips</div> -->
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			types: [
				{
					title: 'One-time Event',
					value: 'one-time',
					description:
						'Host this wrkprty once.  We"ll save your event info so you can host it again in the future.'
				},
				{
					title: 'Recurring Event',
					value: 'recurring',
					description: 'Host this wrkprty recurring every week or month.'
				}
				// { title: 'Series', value: 'series', description: 'Host a series of wrkprtys that progress toward a goal.' },
			]
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.frequency !== null) {
			if (this.frequency === 'recurring') {
				if (this.recurringFrequency !== null) {
					this.setAddEventValidStep(from.path)
					this.removeAddEventInvalidStep(from.path)
				} else {
					this.setAddEventInvalidStep(from.path)
				}
			} else {
				this.setAddEventValidStep(from.path)
				this.removeAddEventInvalidStep(from.path)
			}
		} else {
			this.setAddEventInvalidStep(from.path)
		}
		next()
	},
	methods: {
		...mapActions([
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
			'setAddEventProp',
			'setAddEventValidStep'
		])
	},
	computed: {
		...mapGetters(['getAddEventProp']),
		frequency: {
			get() {
				return this.getAddEventProp('frequency')
			},
			set(val) {
				this.setAddEventProp({ prop: 'frequency', value: val })
			}
		},
		recurringFrequency: {
			get() {
				return this.getAddEventProp('recurringFrequency')
			},
			set(val) {
				this.setAddEventProp({ prop: 'recurringFrequency', value: val })
			}
		},
		infoDialog: {
			get() {
				return this.getAddEventProp('infoDialog')
			},
			set(val) {
				this.setAddEventProp({ prop: 'infoDialog', value: val })
			}
		}
	}
}
</script>

<style>
</style>
